import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../helpers';
import { sliderStyles } from './slider.styles';

const tag = tagName('slider');

@customElement(tag)
export class SliderComponent extends TmElement {
  @property({ type: String, reflect: true })
  label? = 'Slider';

  @property({ type: Number, reflect: true })
  value? = 0;

  @property({ type: Number, reflect: true })
  min = 0;

  @property({ type: Number, reflect: true })
  max = 100;

  @property({ type: Number, reflect: true })
  step = 1;

  static override styles = [...sliderStyles];

  override render() {
    const p50 = Math.round(this.max / 2);
    const p25 = Math.round(p50 / 2);
    const p75 = Math.round(p25 + p50);

    return html`<label for="slider">${this.label}</label>
      <input
        id="slider"
        data-test="slider"
        type="range"
        min="${this.min}"
        max="${this.max}"
        step="${this.step}"
        value="${this.value}"
        @change=${this.#handleChange}
        class="slider"
        list="markers"
      />
      <datalist id="markers">
        <option value="${this.min}"></option>
        <option value="${p25}"></option>
        <option value="${p50}"></option>
        <option value="${p75}"></option>
        <option value="${this.max}"></option>
      </datalist>`;
  }

  #handleChange = (event: Event) => {
    const { value } = event.target as HTMLInputElement;

    this.dispatchLocalEvent({
      eventName: 'change',
      detail: value,
    });
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'a-slider': SliderComponent;
  }
}
